export default __webpack_public_path__ + "static/media/single-project-page-01-img19.4186a1a0.jpg";